export const FETCH_CCM_CONFIG = 'CCM/FETCH_CONFIG_REQUEST';
export const FETCH_CCM_CONFIG_SUCCESS = 'CCM/FETCH_CONFIG_SUCCESS';
export const FETCH_CCM_CONFIG_FAILURE = 'CCM/FETCH_CONFIG_FAILURE';

export const FETCH_CCM_DATA = 'CCM/FETCH_DATA_REQUEST';
export const FETCH_CCM_DATA_SUCCESS = 'CCM/FETCH_DATA_SUCCESS';
export const FETCH_CCM_DATA_FAILURE = 'CCM/FETCH_DATA_FAILURE';

export const SAVE_CCM_DATA = 'CCM/SAVE_DATA_REQUEST';
export const SAVE_CCM_DATA_SUCCESS = 'CCM/SAVE_DATA_SUCCESS';
export const SAVE_CCM_DATA_FAILURE = 'CCM/SAVE_DATA_FAILURE';

export const SELECT_CCM_LANGUAGE = 'CCM/SELECT_LANGUAGE';
export const INIT_CCM_LANGUAGE = 'CCM/INIT_LANGUAGE';

export const CLEAR_CCM_DATA = 'CCM/CLEAR_DATA';
